import { preloadAuth } from '@berky/auth'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app'
import { moduleError } from './modules'
import { ManifestErrorPage } from './pages/manifest-error'
import './styles.css'

// Ganz vorn und außerhalb von `start()`: Der Anmelde-Code wird angefordert,
// während der Rest noch aufgebaut wird — und im Entwicklungsbetrieb, während
// MSW hochfährt. Ohne das beginnt die Anmeldekette erst nach dem ersten
// Rendern, und sie ist der längste Weg bis zur fertigen Navigation.
preloadAuth()

async function start() {
  // MSW nur beim Entwickeln. Die Bedingung ist statisch, deshalb fällt der
  // Import im Produktions-Build komplett weg.
  //
  // `pnpm dev:all` setzt VITE_BERKY_API=host: dann läuft ein echtes Backend und
  // MSW muss aus bleiben — sonst würde es die Aufrufe im Browser abfangen,
  // bevor sie den Vite-Proxy überhaupt erreichen.
  if (import.meta.env.DEV && import.meta.env.VITE_BERKY_API !== 'host') {
    const { startMocks } = await import('./mocks/browser')
    await startMocks()
  }

  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Das Element #root fehlt in der index.html.')
  }

  createRoot(container).render(
    <StrictMode>
      {moduleError ? <ManifestErrorPage error={moduleError} /> : <App />}
    </StrictMode>,
  )
}

void start()
